import React from 'react';
import './App.css';
import Analyzer from './pages/Analyzer';
import { NoteProvider } from './context/NoteContext';

function App() {
  return (
    <NoteProvider>
      <div className="App">
        <Analyzer />
      </div>
    </NoteProvider>
  );
}

export default App;
